import { DropdownMenuItemType, IDropdownOption } from 'office-ui-fabric-react'

export function useInputFieldOptions(): IDropdownOption[] {
  return [
    {
      key: 'general',
      text: 'General',
      itemType: DropdownMenuItemType.Header,
      disabled: true,
    },
    { key: 'title', text: 'Title' },
    { key: 'targetedAssets', text: 'Targeted assets' },
    { key: 'priority', text: 'Priority' },
    {
      key: 'samePriorityBehavior',
      text: 'Same priority behavior',
    },
    {
      key: 'adSource',
      text: 'Ad source',
      itemType: DropdownMenuItemType.Header,
      disabled: true,
    },
    {
      key: 'headerBiddingAdUnitBidAdapterAlias',
      text: 'Header bidding ad unit / Bid adapter alias',
    },
    {
      key: 'headerBiddingAdUnitMinimumPriceFloor',
      text: 'Header bidding ad unit / Minimum price floor',
    },
    {
      key: 'supplyChain',
      text: 'Supply chain',
      itemType: DropdownMenuItemType.Header,
      disabled: true,
    },
    {
      key: 'thirdPartySellerDomain',
      text: 'Third party seller domain',
    },
  ]
}
